import { PAY_INSTALLMENT_GUIDE } from './metadata';

const usePayInstallment = () => {
  return {
    data: PAY_INSTALLMENT_GUIDE,
  };
};

export default usePayInstallment;
